<div class="appContentsContainer">
  <div
    id="mantenimientoContainer"
    class="backgroundSand container fullWidthContainer listPage"
  >
    <div class="pageTitle">Consulta Patrones WLTP</div>
    <div class="filterTableContainer">
      <app-filters
        #insideTable
        [filterList]="filterList"
        (valueFilter)="filterSearch($event)"
        [ngClass]="{ filterHidden: !showTableFilter }"
        (showFilters)="showFilters($event)"
      ></app-filters>
      <app-table
        [tableList]="tableList"
        [elementList]="listItems"
        [numPages]="numPages"
        [numElements]="numElements"
        [totalElements]="totalElements"
        [routing]="routing"
        [filterParams]="filtersTableJSON"
        [options]="options"
        [showFilterButtons]="showFilterButtons"
        (valueFilterTable)="filterTable($event)"
        (headerButtonsActionEvent)="buttonsHeader($event)"
      ></app-table>
      <div class="backButton">
        <button
          class="formButtonBack"
          type="button"
          (click)="goPredefinedMailBox()"
        >
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
      </div>
    </div>
  </div>
</div>
